import Service from "./Service";
import * as icons from "../../../icons";

import Style from "./Services.module.css";
import useScreenSize from "../../../hooks/useScreenSize";
import { useI18n } from "../../../i18n/I18nContext";

const serviceIcons = [
  icons.bulbIcon,
  icons.designIcon,
  icons.developIcon,
  icons.testIcon,
  icons.supportIcon,
];

const ServicesList = () => {
  const { isSmallSize, isMediumSize } = useScreenSize();
  const { copy } = useI18n();

  const isMobile = isSmallSize || isMediumSize;

  return (
    <div
      className={Style["services-list"]}
      style={{ flexDirection: isMobile ? "column" : "row" }}
    >
      {copy.home.services.items.map((service, index) => (
        <Service
          key={service.title}
          title={service.title}
          text={service.description}
          icon={serviceIcons[index]}
        />
      ))}
    </div>
  );
};

export default ServicesList;
